import React, { Suspense } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import ErrorBoundary from "./components/common/Errorboundry";
import PrivateRoute from "./components/common/PrivateRoute";
import Home from "./pages/public/Home";
import RootLayout from "./pages/public/RootLayout";
import { ForgotPassword } from "./pages/public/ForgotPassword";
import ResetPassword from "./pages/public/u1/ResetPassword"; // Reset/Set password redesign, previewed
// TIP-631 — Dashboard home redesign, previewed alongside the live /dashboard.
import Dashboard from "./pages/admin/u1/Dashboard";
// TIP-632 — My Companies redesign, previewed alongside the live screen.
import MyCompany from "./pages/admin/u1/MyCompanies";
import DashboardMembership from "./pages/admin/u1/Membership"; // TIP-633 — Membership redesign, previewed
import TradeInformation from "./pages/admin/u1/TradeInformation";
import TradeFinance from "./pages/admin/u1/TradeFinance";
import TradeRisk from "./pages/admin/u1/TradeRisk";
import Following from "./pages/admin/u1/Following"; // TIP-640 — Following redesign, previewed
import Billing from "./pages/admin/u1/Billing";
import Purchased from "./pages/admin/u1/Purchased"; // TIP-641 — Purchased redesign, previewed
import Enterprise from "./pages/admin/u1/Enterprise"; // Partner Program redesign, previewed
import Help from "./pages/admin/u1/Help"; // Help & Support redesign, previewed
import CompanyEditProfile from "./pages/admin/u1/CompanyEditProfile"; // TIP-644 — Company Edit Profile redesign, previewed
import Profile from "./pages/admin/u1/Profile"; // User Profile redesign — the live page stays on disk at pages/admin/Dashboard/Profile
import SearchPage from "./pages/public/u1/Search"; // TIP-603 Phase 2 — isolated Search redesign
import Login from "./pages/public/u1/Login"; // TIP-6xx — Login redesign, previewed in isolation
import SignUp from "./pages/public/u1/SignUp"; // TIP-6xx — Sign Up redesign, previewed in isolation
// Suffixed because the live claim page is already imported as ClaimCompany below.
import ClaimCompany from "./pages/public/u1/ClaimCompany"; // TIP-629 — claim intake redesign, previewed in isolation
import CompanyProfile from "./pages/public/u1/CompanyProfile"; // Company Profile redesign, previewed
// Suffixed because the live order page is already imported as CreateCompany.
import OrderWebProfile from "./pages/public/u1/OrderWebProfile"; // Order a Web Profile redesign, previewed in isolation
import PaymentDetails from "./pages/public/u1/PaymentDetails"; // Buy-a-Web-Profile payment step redesign, previewed in isolation
import Plans from "./pages/public/u1/Plans"; // Buy-a-Web-Profile plan step redesign, previewed in isolation
import Membership from "./pages/public/u1/Membership"; // Become-a-Member redesign, previewed in isolation
// Dashboard shell uplift — the rail and top bar every dashboard screen sits
// in. The previous layout stays on disk at pages/admin/RootLayoutAdmin.
import RootLayoutAdmin from "./pages/admin/u1/RootLayoutAdmin";
import Request from "./pages/admin/Dashboard/Request";
import { SuccessfulPayment } from "./components/public/Payment/Plans/SuccessfulPayment";
import { TrevexPrivacyPolicy } from "./pages/public/TrevexPrivacyPolicy";
import { TermsAndCondition } from "./pages/public/TermsAndcondition";
import Verification from "./components/common/Verification";
import EnterpriseActivityLogTable from "./components/admin/Dashboard/dashboard/EnterpriseActivityLogTable";
import { EnterpriseTrackedCompanies } from "./components/admin/Dashboard/mycompanies/EnterpriseTrackedCompanies";
import GptPrompts from "./pages/public/GptPrompts";
import { GPT_prompt } from "./components/admin/Dashboard/GPT_prompt";
import ThankYou from "./pages/public/ThankYou";
import TradeLicence from "./pages/public/Upload/TradeLicence";
import PaymentRefHub from "./pages/admin/Dashboard/PaymentRefHub";
import PaymentRefQnA from "./pages/admin/Dashboard/PaymentRefQnA";
import SDKIntegration from "./pages/public/SDKIntegration";
import PaymentScreen from "./components/public/VerifyAccount/PaymentScreen";
// Uplifted replacements for these live in ./pages/admin/u1 and ./pages/public/u1 (imported above).
// import Membership from "./pages/public/Membership"; // TIP-488 — reusable "Become a Member" page
// import DashboardMembership from "./pages/admin/Dashboard/Membership"; // TIP-494 — dashboard membership page
import CounterpartyBriefs from "./pages/admin/Dashboard/CounterpartyBriefs"; // TIP-609 — counterparty briefs page (not yet uplifted)
/* TIP-647 — new on development and genuinely absent here, so it is imported
   rather than commented out like the five above, whose u1 replacements
   already bind these names. */
import MembershipPlans from "./pages/public/MembershipPlans";

const AgentIntake = React.lazy(() => import("./components/public/AgentIntake"));
const RegisterCompany = React.lazy(() => import("./components/public/CompanyRegister"));
const VerifyAccount = React.lazy(() => import("./components/public/VerifyAccount"));
const CompanyRegistration = React.lazy(() => import("./components/public/CompanyRegistration"));

// 1. { path: "/search", element: <ErrorBoundary><PrivateRoute token={false}><Search /></PrivateRoute></ErrorBoundary> },
// 2. { path: "/search/:id", element: <ErrorBoundary><PrivateRoute ><CompanyProfile /></PrivateRoute></ErrorBoundary> },
// 3. { path: "/login", element: <ErrorBoundary><PrivateRoute token={false} isLogin><Login /></PrivateRoute></ErrorBoundary> },
// 4. { path: "/sign-up", element: <ErrorBoundary><PrivateRoute token={false}><SignUp /></PrivateRoute></ErrorBoundary> },
// 5. { path: "/claim/:id", element: <ErrorBoundary><PrivateRoute><ClaimCompany /></PrivateRoute></ErrorBoundary>},

// 6. { path: "/dashboard", element: <ErrorBoundary><PrivateRoute><Dashboard /></PrivateRoute></ErrorBoundary> },
// 7. { path: "/dashboard/my-companies", element: <ErrorBoundary><PrivateRoute><MyCompany /></PrivateRoute></ErrorBoundary> },
// 8. { path: "/dashboard/membership", element: <ErrorBoundary><PrivateRoute><DashboardMembership /></PrivateRoute></ErrorBoundary> },

// 9. { path: "/dashboard/trade-information", element: <ErrorBoundary><PrivateRoute><TradeInformation /></PrivateRoute></ErrorBoundary> },
// 10.{ path: "/dashboard/trade-finance", element: <ErrorBoundary><PrivateRoute><TradeFinance /></PrivateRoute></ErrorBoundary> },
// 11.{ path: "/dashboard/trade-risk", element: <ErrorBoundary><PrivateRoute><TradeRisk /></PrivateRoute></ErrorBoundary> },

// 12.{ path: "/dashboard/following", element: <ErrorBoundary><PrivateRoute><Following /></PrivateRoute></ErrorBoundary> },
// 13.{ path: "/dashboard/enterprise", element: <ErrorBoundary><PrivateRoute><Enterprise /></PrivateRoute></ErrorBoundary> },
// 14.{ path: "/dashboard/purchased", element: <ErrorBoundary><PrivateRoute><Purchased /></PrivateRoute></ErrorBoundary> },
// 15.{ path: "/dashboard/billing", element: <ErrorBoundary><PrivateRoute><Billing /></PrivateRoute></ErrorBoundary> },
// 16.{ path: "/dashboard/help", element: <ErrorBoundary><PrivateRoute><Help /></PrivateRoute></ErrorBoundary> },
// 17.{ path: "/edit/:id", element: <ErrorBoundary><PrivateRoute><CompanyEditProfile /></PrivateRoute></ErrorBoundary> },
// 18.{ path: "/order-web-profile", element: <ErrorBoundary><PrivateRoute><CreateCompany /></PrivateRoute></ErrorBoundary> },
// 19.{ path: "/membership/:companyId", element: <ErrorBoundary><PrivateRoute><Membership /></PrivateRoute></ErrorBoundary> },
// 20.{ path: "/plans", element: <ErrorBoundary><PrivateRoute token={false}><Payment /></PrivateRoute></ErrorBoundary> },
// 21.{ path: "/plans/paymentdetails", element: <ErrorBoundary><PrivateRoute><PaymentDetails /></PrivateRoute></ErrorBoundary> },
// 22.{ path: "/reset-password", element: <ErrorBoundary><PrivateRoute token={false}><ForgotPassword route={"reset"} /></PrivateRoute></ErrorBoundary> },
// 23.{ path: "/set-password", element: <ErrorBoundary><PrivateRoute token={false}><ForgotPassword route={"set"} /></PrivateRoute></ErrorBoundary> },

export const router = createBrowserRouter([
  {
    path: "/",
    children: [{ path: "/", element: <ErrorBoundary><PrivateRoute token={false}><Home /></PrivateRoute></ErrorBoundary> }],
  },
  {
    path: "gpt-prompts/access",
    element: <ErrorBoundary><PrivateRoute token={false}><GPT_prompt to="gpt"/></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/",
    element: <ErrorBoundary><PrivateRoute token={false}><RootLayout liftHeader={true} /></PrivateRoute></ErrorBoundary>,
    children: [
      { path: "/gpt-prompts", element: <ErrorBoundary><PrivateRoute token={false}><GPT_prompt to="gpt" /></PrivateRoute></ErrorBoundary> },
    ],
  },
  {
    path: "/",
    element: <ErrorBoundary><PrivateRoute token={false}><RootLayout /></PrivateRoute></ErrorBoundary>,
    children: [
      { path: "/", element: <ErrorBoundary><PrivateRoute token={false}><Home /></PrivateRoute></ErrorBoundary> },
      // TIP-603 Phase 2 — Search UI redesign served in isolation. Same guard
      // treatment as /search (token={false}); the live /search is untouched.
      { path: "/search", element: <ErrorBoundary><PrivateRoute token={false}><SearchPage /></PrivateRoute></ErrorBoundary> },
      { path: "/gpt-prompts/search", element: <ErrorBoundary><PrivateRoute token={false}><GPT_prompt /></PrivateRoute></ErrorBoundary> },
      { path: "/gpt-prompts/search/:id", element: <ErrorBoundary><PrivateRoute token={false}><GPT_prompt /></PrivateRoute></ErrorBoundary> },
      // Company Profile redesign, previewed alongside the live /search/:id.
      // Same guard treatment as the route above.
      { path: "/search/:id", element: <ErrorBoundary><PrivateRoute><CompanyProfile /></PrivateRoute></ErrorBoundary> },
      // Order a Web Profile redesign, previewed alongside the live
      // /order-web-profile above. Same guard treatment; the live route and the
      // /create-company redirect are untouched.
      { path: "/order-web-profile", element: <ErrorBoundary><PrivateRoute><OrderWebProfile /></PrivateRoute></ErrorBoundary> },
      { path: "/create-company", element: <Navigate to="/order-web-profile" replace /> },
      // TIP-647 — PUBLIC membership page. No company, no login required: a
      // visitor reads the perks and pricing, and the gate on Proceed handles
      // auth + claim. Inside RootLayout so a page that leads to payment carries
      // the site nav and the footer's Privacy Policy / Terms links.
      { path: "/membership", element: <ErrorBoundary><PrivateRoute token={false}><MembershipPlans /></PrivateRoute></ErrorBoundary> },
    ],
  },
  {
    path: "/update/trade-license/:token",
    element: <ErrorBoundary><PrivateRoute token={false}><TradeLicence /></PrivateRoute></ErrorBoundary>,
  },
  {
    // Public route for external agents — authenticated by the 6-char access
    // code inside AgentIntakePage, NOT by the site-wide verification gate
    // (which is consumer-flow only). PrivateRoute deliberately omitted.
    // Lazy-loaded so AgentIntake's CSS/components don't ship in the main bundle.
    path: "/agent-intake/:token",
    element: <ErrorBoundary><Suspense fallback={null}><AgentIntake /></Suspense></ErrorBoundary>,
  },
  {
    // TIP-516 — direct company registration. Same agent-code gate as
    // /agent-intake, but started BLANK (no token in the URL): the page mints a
    // fresh draft Lead on entry and reuses the intake form. PrivateRoute /
    // verification gate deliberately omitted (agent-authenticated, like above).
    path: "/register-company",
    element: <ErrorBoundary><Suspense fallback={null}><RegisterCompany /></Suspense></ErrorBoundary>,
  },
  {
    // TIP-453 — nominee-facing Verify Account page. Token in the URL is the
    // auth credential; PrivateRoute / verification gate skipped for the same
    // reason as the agent intake route above.
    path: "/verify-account/:token",
    element: <ErrorBoundary><Suspense fallback={null}><VerifyAccount /></Suspense></ErrorBoundary>,
  },
  {
    // TIP-581 — agent-shared prefilled self-registration. The prospect opens
    // this link (shared live on the call), edits the pre-filled intake form,
    // sets a password, and submits. Token in the URL is the credential; no
    // agent gate / verification gate (TIP-579 backend, product-approved).
    path: "/company-registration/:token",
    element: <ErrorBoundary><Suspense fallback={null}><CompanyRegistration /></Suspense></ErrorBoundary>,
  },
  {
    path: "/payments",
    element: <ErrorBoundary><Suspense fallback={null}><PaymentScreen /></Suspense></ErrorBoundary>,
  },
  {
    // Become-a-Member redesign, previewed alongside the live
    // /membership/:companyId above. Same guard treatment; the live route is
    // untouched and nothing redirects here.
    path: "/membership/:companyId",
    element: <ErrorBoundary><PrivateRoute><Membership /></PrivateRoute></ErrorBoundary>,
  },
  {
    // TIP-629 — the claim intake. Company search and the "cannot find it"
    // fallback live on /sign-up (redirectToStep 6), as they always have; this
    // route is for claiming a company already identified by its id.
    path: "/claim/:id",
    element: <ErrorBoundary><PrivateRoute><ClaimCompany /></PrivateRoute></ErrorBoundary>,
  },
  {
    // Sign Up redesign, served alongside the live /sign-up while it is
    // reviewed. Same guard treatment; the live route is untouched.
    path: "/sign-up",
    element: <ErrorBoundary><PrivateRoute token={false}><SignUp /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/thank-you",
    children: [{ path: "/thank-you", element: <ErrorBoundary><PrivateRoute token={false}><ThankYou /></PrivateRoute></ErrorBoundary> }],
  },
  {
    path: "/sdk",
    element: <ErrorBoundary><PrivateRoute token={false}><SDKIntegration /></PrivateRoute></ErrorBoundary>,
  },
  {
    // Login redesign, served alongside the live /login while it is reviewed.
    // Same guard treatment as /login (token={false} isLogin); the live route is
    // untouched. Promoting the redesign is a one-line swap of the element above.
    path: "/login",
    element: <ErrorBoundary><PrivateRoute token={false} isLogin><Login /></PrivateRoute></ErrorBoundary>,
  },
  {
    // Reset / Set password redesign, previewed alongside the live routes above.
    // Same guard treatment (token={false}) and the same `route` prop, which is
    // the only thing separating the two flows. The live routes are untouched.
    // BOTH are previewed: one screen serves reset and set, and shipping only
    // half of it would leave the set-password link with no redesign to compare
    path: "/reset-password",
    element: <ErrorBoundary><PrivateRoute token={false}><ResetPassword route={"reset"} /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/set-password",
    element: <ErrorBoundary><PrivateRoute token={false}><ResetPassword route={"set"} /></PrivateRoute></ErrorBoundary>,
  },
  {
    // Plan-step redesign, previewed alongside the live /plans above. Same guard
    // treatment (token={false}); the live route is untouched.
    path: "/plans",
    element: <ErrorBoundary><PrivateRoute token={false}><Plans /></PrivateRoute></ErrorBoundary>,
  },
  {
    // Payment-step redesign, previewed alongside the live /plans/paymentdetails
    // above. Same guard treatment; the live route is untouched, and nothing
    // redirects here — it is reached by URL, as the other /u1/* previews are.
    path: "/plans/paymentdetails",
    element: <ErrorBoundary><PrivateRoute><PaymentDetails /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/plans/paymentsuccessful",
    element: <ErrorBoundary><PrivateRoute><SuccessfulPayment /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/dashboard",
    element: <ErrorBoundary><PrivateRoute><RootLayoutAdmin /></PrivateRoute></ErrorBoundary>,
    children: [
      // TIP-631 — Dashboard home redesign, previewed alongside the live screen.
      { path: "/dashboard", element: <ErrorBoundary><PrivateRoute><Dashboard /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/profile", element: <ErrorBoundary><PrivateRoute><Profile /></PrivateRoute></ErrorBoundary> },
      // TIP-632 — My Companies redesign, previewed alongside the live screen.
      { path: "/dashboard/my-companies", element: <ErrorBoundary><PrivateRoute><MyCompany /></PrivateRoute></ErrorBoundary> },
      // TIP-633 — Membership redesign, previewed alongside the live screen.
      { path: "/dashboard/membership", element: <ErrorBoundary><PrivateRoute><DashboardMembership /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/counterparty-briefs", element: <ErrorBoundary><PrivateRoute><CounterpartyBriefs /></PrivateRoute></ErrorBoundary> },
      // TIP-634 — Trade Information redesign, previewed alongside the live screen.
      { path: "/dashboard/trade-information", element: <ErrorBoundary><PrivateRoute><TradeInformation /></PrivateRoute></ErrorBoundary> },
      // TIP-635 — Trade Finance redesign, previewed alongside the live screen.
      { path: "/dashboard/trade-finance", element: <ErrorBoundary><PrivateRoute><TradeFinance /></PrivateRoute></ErrorBoundary> },
      // TIP-636 — Trade Risk redesign, previewed alongside the live screen.
      { path: "/dashboard/trade-risk", element: <ErrorBoundary><PrivateRoute><TradeRisk /></PrivateRoute></ErrorBoundary> },
      // TIP-637 — Enterprise redesign, previewed alongside the live screen.
      { path: "/dashboard/enterprise", element: <ErrorBoundary><PrivateRoute><Enterprise /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/enterprise/:id", element: <ErrorBoundary><PrivateRoute><EnterpriseTrackedCompanies /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/enterprise/act-log", element: <ErrorBoundary><PrivateRoute><EnterpriseActivityLogTable /></PrivateRoute></ErrorBoundary> },
      // TIP-640 — Following redesign, previewed alongside the live screen.
      { path: "/dashboard/following", element: <ErrorBoundary><PrivateRoute><Following /></PrivateRoute></ErrorBoundary> },
      // TIP-641 — Purchased redesign, previewed alongside the live screen.
      { path: "/dashboard/purchased", element: <ErrorBoundary><PrivateRoute><Purchased /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/payment-ref", element: <ErrorBoundary><PrivateRoute><PaymentRefHub /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/payment-ref/form", element: <ErrorBoundary><PrivateRoute><PaymentRefQnA /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/request", element: <ErrorBoundary><PrivateRoute><Request /></PrivateRoute></ErrorBoundary> },
      // TIP-642 - Billing redesign, previewed alongside the live screen.
      { path: "/dashboard/billing", element: <ErrorBoundary><PrivateRoute><Billing /></PrivateRoute></ErrorBoundary> },
      // Help & Support redesign, previewed alongside the live screen.
      { path: "/dashboard/help", element: <ErrorBoundary><PrivateRoute><Help /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/gpt", element: <ErrorBoundary><PrivateRoute><GPT_prompt to={"gpt"}/></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/article", element: <ErrorBoundary><PrivateRoute><GPT_prompt to={"article"} /></PrivateRoute></ErrorBoundary> },

    ],
  },
  // TIP-644 — Company Edit Profile redesign, previewed alongside the live
  // /edit/:id above. Top level, NOT nested under it: an absolute child path
  // must begin with its parent's combined path or React Router throws at
  {
    path: "/edit/:id",
    element: <ErrorBoundary><PrivateRoute><CompanyEditProfile /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/privacy-policy",
    element: <ErrorBoundary><PrivateRoute token={false}><TrevexPrivacyPolicy /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/terms-and-condition",
    element: <ErrorBoundary><PrivateRoute token={false}><TermsAndCondition /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/verification",
    element: (
      <ErrorBoundary><Verification /></ErrorBoundary>
    ),
  },
  {
    path: "*",
    element: (
      <ErrorBoundary><PrivateRoute token={false}>
        <Login />
      </PrivateRoute></ErrorBoundary>
    ),
  },
]);
